'use client';

import { Input, NumberInput } from '@mantine/core';
import React from 'react';

interface InputMultipleProps {
  defaultValue: InputMultipleValue | undefined;
  onChange: (items: InputMultipleValue | undefined) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

interface InputMultipleValue {
  [key: string]: string | number;
}
function InputMultipleFixed({
  defaultValue,
  onChange,
  className,
  placeholder,
  disabled,
  ...props
}: InputMultipleProps) {
  if (defaultValue == undefined) defaultValue = {};
  const [items, setItems] = React.useState<InputMultipleValue | undefined>(
    defaultValue
  );

  return (
    <div className="col-span-12 grid grid-cols-2 gap-2">
      {items != undefined &&
        placeholder?.split(',').map((current_placeholder, index) => (
          <div className="w-full col-span-1 mb-2" key={index}>
            <Input.Label>{current_placeholder.trim()}</Input.Label>
            <NumberInput
              onBlur={(event) => {
                if (event != undefined) {
                  items[current_placeholder.trim()] = event.target.value;
                  console.log(items);
                  setItems(items);
                  onChange(items);
                }
              }}
              defaultValue={items[current_placeholder.trim()]}
              min={0}
              max={100}
              disabled={disabled}
              suffix="%"
            />
          </div>
        ))}
    </div>
  );
}

export { InputMultipleFixed };
